<section class="split">
  <div>
    <h3 class="title">
      Google Account
    </h3>
    <p class="copy">
      <span>
        You can use the account below to upload Google Sheets into {{ appName }} Datasets.
      </span>
      <a class="link"
        [href]="helpLink"
        target="_blank"
      >
        Learn more
      </a>
    </p>
  </div>
  <capra-button text="Upload a Google Sheet" icon="icon-plus-default" (clicked)="upload()"></capra-button>
</section>

<hr class="divider" />

<section class="split">
  <div class="account">
    <capra-icon
      class="icon"
      icon="illo-google"
    ></capra-icon>
    <div>
      <h3 class="email">
        {{ email }}
      </h3>
      <p class="copy">
        <span>
          Connected on: {{ connectedAt ? (connectedAt | date) : '--' }}
        </span>
        <span class="last-upload">
          Last upload: {{ lastUploadedAt ? (lastUploadedAt | date) : '--' }}
        </span>
      </p>
    </div>
  </div>
  <capra-button text="Disconnect" variant="secondary" color="alert" (clicked)="disconnect()"></capra-button>
</section>
